import { useAccount, usePublicClient, useWalletClient } from 'wagmi';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import useGameDetails from './useGameDetails.js';
import { GetDeepComparedData } from 'utils/Query/index.js';
import { ABI } from 'const/index.js';
import { BigIntsToStr } from 'utils/helpers.js';
import { GetPredictionContractAddr } from 'context/url_based_context.js';

// as returned by the smart contract when called for round #0 and any round user has not bet on
const emptyUserBet_web3js = {
  0: '0', 1: '0', 2: false,
  position: '0', amount: '0', claimed: false
}
const emptyUserBet_RK = {
  0: 0, 1: '0', 2: false,
  position: 0, amount: '0', claimed: false
}

export function IsGivenBetEmpty(bet) {
  if (!bet) throw new SyntaxError('missing required argument: bet')
  return (JSON.stringify(bet) === JSON.stringify(emptyUserBet_web3js))
}


function useUserBetForRoundID(roundID) {
  if (roundID === undefined) throw new SyntaxError('missing required argument: roundID');
  if (isNaN(roundID))
    throw new TypeError('wrong argument type: roundID must be a number, number-convertable string or null');

  const gameDetails = useGameDetails();

  const account = useAccount();
  const publicClient = usePublicClient();


  const { data: userBetData } = useQuery({
    queryKey: ['userBet', roundID, account?.address, gameDetails?.contracts?.prediction._address,
      gameDetails?.wantedChain.id],
    queryFn: FetchUserBetData_RK,
    placeholderData: emptyUserBet_web3js,
    refetchInterval: 5 * 1000,
    staleTime: 1 * 60 * 60 * 1000,
    cacheTime: 4 * 60 * 60 * 1000,
    structuralSharing: GetDeepComparedData,
  });


  /* Rainbowkit */
  async function FetchUserBetData_RK() {
    if (!publicClient || !account?.address) throw new Error('Wallet not connected');
    const _userBetData_array = await publicClient.readContract({
      address: GetPredictionContractAddr(gameDetails),
      abi: ABI.prediction,
      functionName: 'Bets',
      args: [roundID, account?.address],
      //args: [273399, account.address],
    });
    BigIntsToStr(_userBetData_array)

    /* normalize to mimic web3.js format; Wagmi only includes unnamed array items */
    const _userBetData = { ..._userBetData_array };
    _userBetData['position'] = _userBetData[0]
    _userBetData['amount'] = _userBetData[1]
    _userBetData['claimed'] = _userBetData[2]
    return _userBetData;
  }


  return userBetData;
};

export default useUserBetForRoundID;
